import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { useLanguage } from '../hooks/useLanguage';
import { Link } from 'react-router-dom';
export function Footer() {
  const {
    ref,
    isVisible
  } = useScrollReveal(0.1);
  const {
    t,
    direction,
    locale
  } = useLanguage();
  const aboutPath = locale === 'ar' ? '/ar/about' : '/about';
  const cardIssuingPath = locale === 'ar' ? '/ar/services/card-issuing' : '/services/card-issuing';
  const atmAcquiringPath = locale === 'ar' ? '/ar/services/atm-acquiring' : '/services/atm-acquiring';
  const merchantAcquiringPath = locale === 'ar' ? '/ar/services/merchant-acquiring' : '/services/merchant-acquiring';
  const mobilePaymentsPath = locale === 'ar' ? '/ar/services/mobile-payments' : '/services/mobile-payments';
  const consultancyPath = locale === 'ar' ? '/ar/services/consultancy' : '/services/consultancy';
  const otherServicesPath = locale === 'ar' ? '/ar/services/other-services' : '/services/other-services';
  const mobileAppPath = locale === 'ar' ? '/ar/mobile-app' : '/mobile-app';
  const privacyPolicyPath = locale === 'ar' ? '/ar/privacy-policy' : '/privacy-policy';
  const ourToolsPath = locale === 'ar' ? '/ar/services/our-tools' : '/services/our-tools';
  const careersPath = locale === 'ar' ? '/ar/careers' : '/careers';
  const contactPath = locale === 'ar' ? '/ar/contact' : '/contact';
  const partnersPath = locale === 'ar' ? '/ar/partners' : '/partners';
  const corporateGovernancePath = locale === 'ar' ? '/ar/corporate-governance' : '/corporate-governance';
  const advisorsAuditorsPath = locale === 'ar' ? '/ar/advisors-auditors' : '/advisors-auditors';
  const newsPath = locale === 'ar' ? '/ar/news' : '/news';
  const publicationsPath = locale === 'ar' ? '/ar/publications' : '/publications';
  return <footer className="bg-[#061D76] text-white pt-16 pb-8 px-6 md:px-12" dir={direction} data-id="element-131">
      <div ref={ref} className={`max-w-7xl mx-auto reveal-hidden ${isVisible ? 'animate-fade-up' : ''}`} data-id="element-132">
        {/* Desktop: 5-column grid | Mobile: stacked layout */}
        <div className="hidden md:grid md:grid-cols-5 gap-8 mb-12" data-id="element-133">
          {/* Column 1 */}
          <div className="flex flex-col gap-3" data-id="element-134">
            <Link to={aboutPath} className="text-white hover:text-white/80 text-sm transition-colors" data-id="element-135">
              {t('footer.about')}
            </Link>
            <Link to={corporateGovernancePath} className="text-white hover:text-white/80 text-sm transition-colors" data-id="element-136">
              {t('header.corporateGovernance')}
            </Link>
            <Link to={advisorsAuditorsPath} className="text-white hover:text-white/80 text-sm transition-colors" data-id="element-137">
              {t('header.advisorsAuditors')}
            </Link>
            <Link to={newsPath} className="text-white hover:text-white/80 text-sm transition-colors" data-id="element-138">
              {t('footer.news')}
            </Link>
            <Link to={publicationsPath} className="text-white hover:text-white/80 text-sm transition-colors" data-id="element-139">
              {t('footer.publications')}
            </Link>
            <Link to={partnersPath} className="text-white hover:text-white/80 text-sm transition-colors" data-id="element-140">
              {t('footer.partners')}
            </Link>
            <Link to={mobileAppPath} className="text-white hover:text-white/80 text-sm transition-colors" data-id="element-141">
              {t('footer.mobileApp')}
            </Link>
          </div>

          {/* Column 2 */}
          <div className="flex flex-col gap-3" data-id="element-142">
            <Link to={cardIssuingPath} className="text-white hover:text-white/80 text-sm transition-colors" data-id="element-143">
              {t('footer.cardIssuing')}
            </Link>
            <Link to={atmAcquiringPath} className="text-white hover:text-white/80 text-sm transition-colors" data-id="element-144">
              {t('footer.atmAcquiring')}
            </Link>
            <Link to={merchantAcquiringPath} className="text-white hover:text-white/80 text-sm transition-colors" data-id="element-145">
              {t('footer.merchantAcquiring')}
            </Link>
            <Link to={mobilePaymentsPath} className="text-white hover:text-white/80 text-sm transition-colors" data-id="element-146">
              {t('footer.mobilePayment')}
            </Link>
            <Link to={consultancyPath} className="text-white hover:text-white/80 text-sm transition-colors" data-id="element-147">
              {t('footer.consultancy')}
            </Link>
            <Link to={otherServicesPath} className="text-white hover:text-white/80 text-sm transition-colors" data-id="element-148">
              {t('footer.otherServices')}
            </Link>
            <Link to={ourToolsPath} className="text-white hover:text-white/80 text-sm transition-colors" data-id="element-149">
              {t('footer.tools')}
            </Link>
          </div>

          {/* Column 3 */}
          <div className="flex flex-col gap-3" data-id="element-150">
            <Link to={careersPath} className="text-white hover:text-white/80 text-sm transition-colors" data-id="element-151">
              {t('footer.careers')}
            </Link>
            <Link to={contactPath} className="text-white hover:text-white/80 text-sm transition-colors" data-id="element-152">
              {t('footer.contact')}
            </Link>
            <Link to={privacyPolicyPath} className="text-white hover:text-white/80 text-sm transition-colors" data-id="element-153">
              {t('footer.privacy')}
            </Link>
          </div>

          {/* Payment logos */}
          <div className="flex items-start justify-center" data-id="element-154">
            <img src="https://cdn.magicpatterns.com/uploads/6wAmayCRzpCPVcLqMd9dGg/payments.png" alt="Visa & Mastercard" className="h-10 object-contain" data-id="element-155" />
          </div>

          {/* Social icons */}
          <div className={`flex items-start ${direction === 'rtl' ? 'justify-start' : 'justify-end'} gap-[15px]`} data-id="element-156">
            <a href="#" className="hover:opacity-80 transition-opacity flex items-center justify-center" data-id="element-157">
              <img src="https://cdn.magicpatterns.com/uploads/rSSjE9Wn23xFZLFiZ6vJYj/fb.svg" alt="Facebook" className="w-[30px] h-[30px]" data-id="element-158" />
            </a>
            <a href="#" className="hover:opacity-80 transition-opacity flex items-center justify-center" data-id="element-159">
              <img src="https://cdn.magicpatterns.com/uploads/mjn6qH5SzK4WCznzVJYbbz/x.svg" alt="X" className="w-[30px] h-[30px]" data-id="element-160" />
            </a>
            <a href="#" className="hover:opacity-80 transition-opacity flex items-center justify-center" data-id="element-161">
              <img src="https://cdn.magicpatterns.com/uploads/biKJZMvQynJnHqH4rfbhLR/insta.svg" alt="Instagram" className="w-[30px] h-[30px]" data-id="element-162" />
            </a>
            <a href="#" className="hover:opacity-80 transition-opacity flex items-center justify-center" data-id="element-163">
              <img src="https://cdn.magicpatterns.com/uploads/2uzf4oJQbXRr4ezgikfzBh/linkedin.svg" alt="LinkedIn" className="w-[30px] h-[30px]" data-id="element-164" />
            </a>
          </div>
        </div>

        {/* Mobile layout */}
        <div className="flex flex-col gap-8 mb-12 md:hidden" data-id="element-165">
          {/* Link columns in 2-col grid */}
          <div className="grid grid-cols-2 gap-x-6 gap-y-8" data-id="element-166">
            {/* Column 1 - Company */}
            <div className="flex flex-col gap-3" data-id="element-167">
              <span className="text-[#25B8D6] font-semibold text-xs uppercase tracking-wider mb-1" data-id="element-168">
                {t('footer.company')}
              </span>
              <Link to={aboutPath} className="text-white/80 hover:text-white text-sm transition-colors" data-id="element-169">
                {t('footer.about')}
              </Link>
              <Link to={corporateGovernancePath} className="text-white/80 hover:text-white text-sm transition-colors" data-id="element-170">
                {t('header.corporateGovernance')}
              </Link>
              <Link to={advisorsAuditorsPath} className="text-white/80 hover:text-white text-sm transition-colors" data-id="element-171">
                {t('header.advisorsAuditors')}
              </Link>
              <Link to={partnersPath} className="text-white/80 hover:text-white text-sm transition-colors" data-id="element-172">
                {t('footer.partners')}
              </Link>
              <Link to={mobileAppPath} className="text-white/80 hover:text-white text-sm transition-colors" data-id="element-173">
                {t('footer.mobileApp')}
              </Link>
            </div>

            {/* Column 2 - Services */}
            <div className="flex flex-col gap-3" data-id="element-174">
              <span className="text-[#25B8D6] font-semibold text-xs uppercase tracking-wider mb-1" data-id="element-175">
                {t('footer.services')}
              </span>
              <Link to={cardIssuingPath} className="text-white/80 hover:text-white text-sm transition-colors" data-id="element-176">
                {t('footer.cardIssuing')}
              </Link>
              <Link to={atmAcquiringPath} className="text-white/80 hover:text-white text-sm transition-colors" data-id="element-177">
                {t('footer.atmAcquiring')}
              </Link>
              <Link to={merchantAcquiringPath} className="text-white/80 hover:text-white text-sm transition-colors" data-id="element-178">
                {t('footer.merchantAcquiring')}
              </Link>
              <Link to={mobilePaymentsPath} className="text-white/80 hover:text-white text-sm transition-colors" data-id="element-179">
                {t('footer.mobilePayment')}
              </Link>
              <Link to={consultancyPath} className="text-white/80 hover:text-white text-sm transition-colors" data-id="element-180">
                {t('footer.consultancy')}
              </Link>
              <Link to={otherServicesPath} className="text-white/80 hover:text-white text-sm transition-colors" data-id="element-181">
                {t('footer.otherServices')}
              </Link>
              <Link to={ourToolsPath} className="text-white/80 hover:text-white text-sm transition-colors" data-id="element-182">
                {t('footer.tools')}
              </Link>
            </div>
          </div>

          {/* Support links */}
          <div className="flex flex-col gap-3" data-id="element-183">
            <span className="text-[#25B8D6] font-semibold text-xs uppercase tracking-wider mb-1" data-id="element-184">
              {t('footer.support')}
            </span>
            <Link to={careersPath} className="text-white/80 hover:text-white text-sm transition-colors" data-id="element-185">
              {t('footer.careers')}
            </Link>
            <Link to={contactPath} className="text-white/80 hover:text-white text-sm transition-colors" data-id="element-186">
              {t('footer.contact')}
            </Link>
            <Link to={privacyPolicyPath} className="text-white/80 hover:text-white text-sm transition-colors" data-id="element-187">
              {t('footer.privacy')}
            </Link>
          </div>

          {/* Divider */}
          <div className="w-full h-px bg-white/10" data-id="element-188" />

          {/* Payment + Social row */}
          <div className="flex items-center justify-between" data-id="element-189">
            <img src="https://cdn.magicpatterns.com/uploads/6wAmayCRzpCPVcLqMd9dGg/payments.png" alt="Visa & Mastercard" className="h-8 object-contain" data-id="element-190" />
            <div className="flex items-center gap-4" data-id="element-191">
              <a href="#" className="hover:opacity-80 transition-opacity" data-id="element-192">
                <img src="https://cdn.magicpatterns.com/uploads/rSSjE9Wn23xFZLFiZ6vJYj/fb.svg" alt="Facebook" className="w-[28px] h-[28px]" data-id="element-193" />
              </a>
              <a href="#" className="hover:opacity-80 transition-opacity" data-id="element-194">
                <img src="https://cdn.magicpatterns.com/uploads/mjn6qH5SzK4WCznzVJYbbz/x.svg" alt="X" className="w-[28px] h-[28px]" data-id="element-195" />
              </a>
              <a href="#" className="hover:opacity-80 transition-opacity" data-id="element-196">
                <img src="https://cdn.magicpatterns.com/uploads/biKJZMvQynJnHqH4rfbhLR/insta.svg" alt="Instagram" className="w-[28px] h-[28px]" data-id="element-197" />
              </a>
              <a href="#" className="hover:opacity-80 transition-opacity" data-id="element-198">
                <img src="https://cdn.magicpatterns.com/uploads/2uzf4oJQbXRr4ezgikfzBh/linkedin.svg" alt="LinkedIn" className="w-[28px] h-[28px]" data-id="element-199" />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className={`max-w-7xl mx-auto pt-8 border-t border-white/10 reveal-hidden ${isVisible ? 'animate-fade-up delay-300' : ''}`} data-id="element-200">
        <p className="text-white text-xs" data-id="element-201">{t('footer.copyright')}</p>
      </div>
    </footer>;
}